/**
 * User-facing message for a failed two-factor setup or verification.
 * Supabase AuthErrors carry a stable `code`; anything else falls back to its
 * message.
 */

const MESSAGES_BY_CODE: Record<string, string> = {
  mfa_verification_failed:
    "That code didn't match. Enter the current 6-digit code from your authenticator app.",
  mfa_challenge_expired: 'That code expired. Enter the current code from your authenticator app.',
  over_request_rate_limit: 'Too many attempts. Wait a minute, then try again.',
  too_many_requests: 'Too many attempts. Wait a minute, then try again.',
};

const FALLBACK_MESSAGE = 'Something went wrong. Please try again.';

export function totpErrorMessage(error: unknown): string {
  const code =
    typeof error === 'object' && error !== null && 'code' in error ? error.code : undefined;
  if (typeof code === 'string' && MESSAGES_BY_CODE[code]) {
    return MESSAGES_BY_CODE[code];
  }
  return error instanceof Error && error.message ? error.message : FALLBACK_MESSAGE;
}
